var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrossSmallRed = function SvgIconCrossSmallRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E53935",
    d: "m1.605 8.03-.886-.886L3.863 4 .719.877l.886-.887 3.144 3.145L7.873-.01l.886.887L5.615 4l3.144 3.144-.887.886L4.75 4.886z"
  })));
};
export default SvgIconCrossSmallRed;